import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import SelfServeRecipientBuilderEnum from 'SelfServeRecipientBuilder/SelfServeRecipientBuilderConstants';
import DocumentShareConstants from 'DocumentShare/DocumentShareConstants';

import RequestSignatureConstants from './RequestSignatureConstants';

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

export const enableRecipientSignature = () => (
  (dispatch) => {
    dispatch({
      type: RequestSignatureConstants.RECIPIENT_SIGNATURE_ENABLE,
    });
  }
);

export const showTermsOfServiceErrorBanner = () => (
  (dispatch) => {
    dispatch({
      type: RequestSignatureConstants.TERMS_OF_SERVICE_ERROR_SHOW,
    });
  }
);

export const declineDocumentShare = (shareKey, onSuccess, onError) => (
  async (dispatch) => {
    try {
      await formSwiftAPIClient.request('POST', `/document-share/${shareKey}/decline`);
      onSuccess();
      dispatch({
        type: SelfServeRecipientBuilderEnum.SELF_SERVE_RECIPIENT_BUILDER_SET_FINISHED,
        accessLevel: DocumentShareConstants.DECLINED_DONE_MODE,
      });
    } catch (e) {
      window.Raven.captureException(e);
      onError();
      dispatch({
        type: SelfServeRecipientBuilderEnum.SELF_SERVE_RECIPIENT_BUILDER_SET_FINISHED_FAILURE,
        error: e.message,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/Popups/RequestSignaturePopupWrapper/RequestSignatureActions.jsx